/**
* 判断是否是手机号
*/
export function isCellPhoneNumber(phone) {
    const telReg = /^1[23456789]\d{9}$/;
    return !telReg.test(phone)
}
